// FIREBASE REMOVED: safeConsole unused
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Critical CSS imports - Load first for proper styling
import './design-system/styles/globals.css';
import './design-system/themes/index.css';
import './design-system/styles/enhanced-variables.css';
// Page-specific CSS imports - Load globally to avoid chunk loading issues
import './design-system/styles/pages/sales-invoice.css';

// TypeScript tip tanımlamaları
declare global {
  interface Window {
    __chunkReloadGuard?: { reloaded: boolean };
  }
}

// Uygulamanın kök bileşenini oluştur ve render et
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element bulunamadı');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  // React.StrictMode dev'de çift render yapar, prod'da kapalıdır
  // Geliştirme hızı için geçici olarak kaldırıyoruz
  <App />
);

// Performans ölçümü için (isteğe bağlı)
reportWebVitals();

// Runtime ChunkLoadError kurtarma: Bir kez sert yenileme ile toparla
// Amaç: Lazy loaded chunk adları/caching kaynaklı hatalarda kullanıcıyı kilitlenmeden kurtarmak
if (typeof window !== 'undefined') {
  if (!window.__chunkReloadGuard) {
    window.__chunkReloadGuard = { reloaded: false };
  }

  const shouldHandleChunkError = (message: string): boolean =>
    typeof message === 'string' && message.includes('ChunkLoadError');

  const hardReload = (): void => {
    if (!window.__chunkReloadGuard) return;
    if (window.__chunkReloadGuard.reloaded) return;
    console.warn('[ChunkErrorHandler] ⚠️ hardReload tetiklendi - sayfa yenilenecek!');
    window.__chunkReloadGuard.reloaded = true;
    // Sert yenileme (cache bypass denemesi)
    window.location.reload();
  };

  // unhandledrejection (dinamik import hataları sıklıkla buraya düşer)
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    try {
      const reason = event && event.reason ? String(event.reason) : '';
      console.log('[UnhandledRejection] Event yakalandı:', reason.substring(0, 200));
      if (shouldHandleChunkError(reason)) {
        console.warn('[ChunkErrorHandler] ⚠️ ChunkLoadError tespit edildi, hardReload çağrılıyor');
        hardReload();
      }
    } catch (_) {}
  });

  // error event (bazı chunk hataları buraya düşebilir)
  window.addEventListener('error', (event: ErrorEvent) => {
    try {
      const message = event && event.message ? String(event.message) : '';
      if (message) {
        console.log('[ErrorEvent] Error yakalandı:', message.substring(0, 200));
      }
      if (shouldHandleChunkError(message)) {
        console.warn('[ChunkErrorHandler] ⚠️ ChunkLoadError tespit edildi, hardReload çağrılıyor');
        hardReload();
      }
    } catch (_) {}
  }, true);
}

// Enhanced Service Worker Registration - Works in both development and production
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW: Enhanced service worker registered successfully');
        // Check for updates (only in production)
        if (process.env.NODE_ENV === 'production') {
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker available
                  if (window.confirm('Yeni sürüm mevcut. Sayfayı yenilemek ister misiniz?')) {
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                  }
                }
              });
            }
          });
        }
      })
      .catch((error) => {
        console.warn('SW: Service worker registration failed:', error);
      });
  });
}
